module.exports = __webpack_public_path__ + "static/media/ExperienceSummerCamp_LOGO_COLORE-002.642f6c0b.png";